import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';

const ConfirmDeleteDocumentDialog = ({ onClose, onDelete, documentName }) => {
    const handleDelete = e => {
        e.preventDefault();
        onDelete(documentName);
        onClose();
    };

    return (
        <Dialog onClose={onClose} open={true}>
            <DialogTitle sx={{ wordWrap: 'break-word' }}>Delete Document: {documentName}</DialogTitle>
            <DialogContent>
                <Alert severity="warning" sx={{ marginBottom: '10px' }}>Are you sure you want to delete this document from your account?</Alert>
                <DialogContentText>
                    This document may have been used in previous campaigns. Deleting it means that links to this document will no longer work.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleDelete}>Delete Document</Button>
                <Button variant="outlined" onClick={onClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDeleteDocumentDialog;